export const BADGE_SIZES = {
  MINI: 'mini', // 16px x 16px
  SMALL: 'small', // 32px x 32px
  DEFAULT: 'middle', // 48px x 48px
  LARGE: 'large', // 64px x 64px
  XLARGE: 'xlarge', // 100px x 100px
};
